/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import AdminModal from '../../../../../components/AdminModal';
import TextInput from '../../../../../components/input';
// import ModalFormComp from '../../../../../components/ModalFormComp';
import SelectSearch from '../../../../../components/SelectSearch';
import useForm from '../../../../../customHooks/useForm';
import useToast from '../../../../../customHooks/useToast';
import { EDIT_STAFF, INVITE_NEW_STAFF } from '../../../../../graphql/admin_mutations';
import { GET_ALL_ROLES } from '../../../../../graphql/admin_queries';
import useCustomQuery from '../../../../../network/useCustomQuery';
import Styles from './InviteMemeber.module.scss';
// import SuccessfulInvitePopup from './NewInviteSuccessPopup';

interface IInviteNewStaff{
  closeModal?:any;
  refetchData?:any;
  editDetails?:any;
}
const InviteNewStaff = ({ closeModal, refetchData, editDetails }:IInviteNewStaff) => {
  const Toast = useToast();
  const [dept, setDept] = useState('');
  const [role, setRole] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const listDept = [{ label: 'Project Management', value: 'Project Management' },
    { label: 'Product Marketing', value: 'Product Marketing' },
    { label: 'Product Design', value: 'Product Design' },
    { label: 'Product Engineering', value: 'Product Engineering' },
    { label: 'People Operations', value: 'People Operations' },
    { label: 'Sales', value: 'Sales' },
    { label: 'Quality Assurance', value: 'Quality Assurance' },
    { label: 'Reconciliation and Settlement', value: 'Reconciliation and Settlement' },
    { label: 'Credit Risk', value: 'Credit Risk' },
    { label: 'Data Science', value: 'Data Science' },
    { label: 'Customer Experience ', value: 'Customer Experience ' },

  ];

  const [roleList, setRoleList] = useState([]);

  const {
    formValues, handleChange, resetForm,
  } = useForm(
    {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
    {},
    Toast,
  );

  const [getAllRoles, , allRoles] = useCustomQuery({
    query: GET_ALL_ROLES,
    onError: () => {},
    onData: () => {},
  });

  const [createNewStaff, { loading: inviteNewStaffLoading }] = useMutation<
  { inviteNewStaff: any },
  any
>(INVITE_NEW_STAFF);

  const [editNewStaff, { loading: editNewStaffLoading }] = useMutation<
{ editStaff: any },
any
>(EDIT_STAFF);

  useEffect(() => {
    getAllRoles();
  }, []);

  useEffect(() => {
    const distructureRoles = allRoles?.getAllRoles?.roles?.map((list) => ({
      label: list?.display_name || list?.name,
      value: list?.id,
    }));

    setRoleList(distructureRoles);
  }, [allRoles]);

  const createInviteStaff = async () => {
    // refetchData(true);
    if (!formValues?.firstName || !formValues?.lastName || !formValues?.email || !formValues?.phone || !dept || !role) {
      Toast.error('all fields are required.');
      return;
    }

    const input = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      email: formValues?.email,
      phone: formValues?.phone,
      department: dept,
      roleId: role,
    };
    if (!inviteNewStaffLoading) {
      try {
        const res = await createNewStaff({
          variables: { input },
        });

        if (res?.data?.inviteNewStaff && res?.data?.inviteNewStaff?.status === 200) {
          // Toast.success(res?.data?.inviteNewStaff?.message || 'Operation was successful');

          setShowSuccessPopup(true);

          refetchData();
        } else {
          Toast.error(res?.data?.inviteNewStaff?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
    setDept('');
    setRole('');
    resetForm({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',

    });
  };

  const editInviteStaff = async () => {
    refetchData(true);
    if (!formValues?.firstName || !formValues?.lastName || !formValues?.email || !formValues?.phone || !dept || !role) {
      Toast.error('all fields are required.');
      return;
    }

    const input = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      phone: formValues?.phone,
      department: dept,
      roleId: role,
    };
    if (!editNewStaffLoading) {
      try {
        const res = await editNewStaff({
          variables: { adminId: editDetails?.id, input },
        });

        if (res?.data?.editStaff && res?.data?.editStaff?.status === 200) {
          // Toast.success(res?.data?.editStaff?.message || 'Operation was successful');
          refetchData(false);
          setShowSuccessPopup(true);
          // setSuccessfulInviteName({
          //   firstName: formValues?.firstName,
          //   lastName: formValues?.lastName,
          // });
        } else {
          Toast.error(res?.data?.editStaff?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  const handleSubmit = async () => {
    if (editDetails) {
      editInviteStaff();
      return;
    }
    createInviteStaff();
  };

  useEffect(() => {
    resetForm({
      firstName: editDetails?.firstName,
      lastName: editDetails?.lastName,
      email: editDetails?.email,
      phone: editDetails?.phone,

    });
    setDept(editDetails?.department);

    const getEditRole = roleList?.find((list) => list?.value === editDetails?.role?.id);
    setRole(getEditRole?.value);
  }, [editDetails, roleList]);

  const getTitle = (type?:string) => {
    switch (type) {
    case 'title':

      return {
        create: showSuccessPopup ? 'Member Invited' : 'Invite Team Member',
        edit: showSuccessPopup ? 'Profile Updated' : 'Edit Profile',
      };

    default:
      return {
        create: showSuccessPopup ? 'A new team member has been invited successfully.' : 'You can add a new user here',
        edit: showSuccessPopup ? 'Your profile has been updated successfully.' : 'You can edit this user here',
      };
    }
  };

  return (

    <AdminModal
      headText={editDetails ? getTitle('title')?.edit : getTitle('title')?.create}
      subText={editDetails ? getTitle()?.edit : getTitle()?.create}
      actionBtnName={editDetails ? 'save changes' : 'invite member'}
      handleModalAction={handleSubmit}
      titleClassName={!showSuccessPopup && Styles.wrapper__title}
      isShow
      isActionBtnDisabled={inviteNewStaffLoading || editNewStaffLoading}
      isSuccess={showSuccessPopup}
      isTopIcon
      onClickAway={closeModal}
      onClose={closeModal}
      isLoading={inviteNewStaffLoading || editNewStaffLoading}
      hideLogo
      cancelBtnClass={Styles.wrapper__cancelBtn}
      subTitleClassName={!showSuccessPopup && Styles.wrapper__subtitle}
      // actionBtnClass={showSuccessPopup ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
    >
      {
        !showSuccessPopup && (
        <div style={{ width: '100%' }}>
          <div>
            <TextInput name="firstName" isRequired value={formValues?.firstName} label="First Name" customOnChange={handleChange} width="100%" />
          </div>
          <div>
            <TextInput name="lastName" isRequired value={formValues?.lastName} label="Last Name" customOnChange={handleChange} width="100%" />
          </div>
          <div>
            <TextInput name="email" isRequired value={formValues?.email} label="Email Address" customOnChange={handleChange} width="100%" disabled={!!editDetails} />
          </div>
          <div>
            <TextInput name="phone" isRequired value={formValues?.phone} label="Phone Number" customOnChange={handleChange} width="100%" />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <SelectSearch
              label=""
              options={listDept}
              placeholder="Select Department"
              name="Select Department"
              value={dept}
              classes={false}
              hideLabel
              isRequired
              onChange={(e) => setDept(e?.target?.value)}
              disabled={false}
            />
          </div>
          <div>
            <SelectSearch
              label=""
              options={roleList}
              placeholder="Select Role"
              name="Select Role"
              value={role}
              classes={false}
              isRequired
              hideLabel
              onChange={(e) => setRole(e?.target?.value)}
              disabled={false}
            />
          </div>
        </div>
        )
      }

    </AdminModal>
  );
};
export default InviteNewStaff;
